// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"31":"c23d3689","33":"e12c73c8","207":"920035d8","385":"4c49a86e","389":"c3f9f6ef","623":"ef1c3d14","635":"8e22633f","787":"b8a195f4","853":"8c91d6c6","920":"c563eb74"}[chunkId] + ".chunk.css";
};